import { render, staticRenderFns } from "./signGoods.vue?vue&type=template&id=351e9e8b&scoped=true&"
import script from "./signGoods.vue?vue&type=script&lang=js&"
export * from "./signGoods.vue?vue&type=script&lang=js&"
import style0 from "./signGoods.vue?vue&type=style&index=0&id=351e9e8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e9e8b",
  null
  
)

export default component.exports